import { useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogActions, DialogContent, TextField } from "@mui/material";
import Loader from "../../../../components/common/loader/Loader";

export interface CommentInputModalProps {
  open: boolean;
  onClose: (value: boolean) => void;
  asyncSubmitOperation: CallableFunction;
  closeModalAfterSubmit?: boolean;
  title: string;
  submitButtonName: string;
}

const CommentInputModal = (props: CommentInputModalProps) => {
  const { onClose, open } = props;
  const [isOperationInProgress, setOperationInProgress] = useState(false);
  const [comment, setComment] = useState<string>("");

  const handleClose = () => {
    onClose(false);
  };

  const handleCommentChange = (event: any) => {
    setComment(event.target.value);
  };

  const _executeOperation = async () => {
    setOperationInProgress(true);
    await props.asyncSubmitOperation(comment);
    setOperationInProgress(false);
    setComment("");
    handleClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth="sm">
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          backgroundColor: "primary.main",
          color: (theme) => theme.palette.grey[50],
        }}
      >
        {props.title}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          value={comment}
          placeholder="Provide your comment"
          onChange={handleCommentChange}
          multiline
          rows={6}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => _executeOperation()}
          size="small"
          disabled={!comment}
        >
          {props.submitButtonName}
        </Button>
        <Button variant="outlined" onClick={handleClose} size="small">
          Cancel
        </Button>
      </DialogActions>
      <Loader isLoading={isOperationInProgress} />
    </Dialog>
  );
};

export default CommentInputModal;
